import { createAsyncThunk } from '@reduxjs/toolkit';
import { ReportByIdApiResponse } from 'src/types/reportingTypes';
import { pushToast } from '../reportingSlice';

export const fetchReportById = createAsyncThunk<
	ReportByIdApiResponse,
	FetchReportByIdPayload,
	{ rejectValue: string }
>(
	'reporting/fetchReportById',
	async ({ api, id, reportId }, {dispatch, rejectWithValue }) => {
		try {
			const response = await api.getUnifiedReportDataById(id, reportId);
			return response;
		} catch (error) {
			const message =
				error instanceof Error
					? error.message
					: 'An unexpected error occurred';
			dispatch(
				pushToast({
					type: 'error',
					message: `Failed to fetch report. Please try again later.`,
				}),
			);
			return rejectWithValue(message);
		}
	},
);

type FetchReportByIdPayload = {
	api: {
		getUnifiedReportDataById: (
			id: string,
			reportId: string,
		) => Promise<ReportByIdApiResponse>;
	};
	id: string;
	reportId: string;
};
